import Cropper from 'cropperjs';

// this is tightly coupled to the displayApp. DO NOT USE OUTSIDE OF RECOMMENDATION WINDOWS
export default class CropperButton {
    constructor(container, elementToCrop, displayApp, options = null) {
        this.container = container;
        this.elementToCrop = elementToCrop;
        this.displayApp = displayApp;
        this.options = options ?? this.getDefaultOptions();
        this.cropper = null;

        this.startButton = this.container.querySelector('#start-button');
        this.backButtonContainer = this.container.querySelector('#back-button-container');
        this.backButton = this.backButtonContainer.querySelector('#back-button');
        this.submitButton = this.container.querySelector('#back-button-container #submit-crop-button');
        this.undoButton = this.container.querySelector('#undo-button');

        // Old product text
        this.oldProductText = this.displayApp.root.querySelector('#main-product-title').innerText;

        // mobile buttons
        this.mobileSortBy = this.displayApp.root.querySelector('#filtersContainerMobile');
        this.uploadButton = this.displayApp.root.querySelector('[uploadbuttonslotm]');
        this.mobileGoBack = this.displayApp.root.querySelector('#back-button-container-mobile');

        this.interacted = false;
        // this.validateDisplayAppImplementation();
    }

    firstInteractionHook() {
        if (this.interacted) return false;
        this.initalProductData = { ...this.displayApp.currentProduct };
        this.initalRecommendation = [...this.displayApp.recommendations];
        this.interacted = true;
        return true;
    }

    init() {
        // All of them
        this.startButton.addEventListener('click', this.handleStartButtonClick.bind(this));
        this.backButton.addEventListener('click', this.handleBackButtonClick.bind(this));
        this.submitButton.addEventListener('click', this.handleSubmitButtonClick.bind(this));
        this.undoButton.addEventListener('click', this.handleUndoButtonClick.bind(this));

        // Mobile only ones
        const mobileBackButton = this.displayApp.root.querySelector('#back-button-container-mobile');
        mobileBackButton.addEventListener('click', this.handleBackButtonClick.bind(this));

        const mobileSubmitButton = this.displayApp.root.querySelector('#submit-crop-button-mobile');
        mobileSubmitButton.addEventListener('click', this.handleSubmitButtonClick.bind(this));

        const mobileUndoButton = this.displayApp.root.querySelector('#undo-button-mobile');
        mobileUndoButton.addEventListener('click', this.handleUndoButtonClick.bind(this));

        return true;
    }

    handleUndoButtonClick() {
        this.displayApp.updateDataView(this.initalProductData, this.initalRecommendation);
        this.displayButtonNormal();
    }

    async handleSubmitButtonClick() {
        await this.processImage();
        this.cropper.destroy();
        this.displayUndoButton();
    }

    handleBackButtonClick() {
        this.cropper.destroy();
        this.displayButtonNormal();
    }

    handleStartButtonClick() {
        this.firstInteractionHook();
        this.startCropper();
        this.displayButtonGoBack();
    }

    displayUndoButton() {
        this.undoButton.style.display = 'flex';
        this.startButton.style.display = 'none';
        this.backButtonContainer.style.display = 'none';
        return true;
    }

    updateProductText(text) {
        this.displayApp.root.querySelector('#main-product-title').innerText = text;
    }

    displayButtonGoBack() {
        // Hide the mobile SortBy Section as we will display content there
        // !! This is some tricky code, we should refactor this to be more clear
        if (this.mobileSortBy) this.mobileSortBy.style.display = 'none';
        if (this.uploadButton) this.uploadButton.style.display = 'none';
        if (this.mobileGoBack) this.mobileGoBack.style.display = 'flex';

        this.oldProductText = this.displayApp.root.querySelector('#main-product-title').innerText;
        this.updateProductText(this.displayApp.language.upload_recommendation_window['crop-help']);

        this.startButton.style.display = 'none';
        this.undoButton.style.display = 'none';
        this.backButtonContainer.style.display = 'flex';
        return true;
    }

    displayButtonNormal() {
        if (this.mobileSortBy) this.mobileSortBy.style.display = 'flex';
        if (this.uploadButton) this.uploadButton.style.display = 'flex';
        if (this.mobileGoBack) this.mobileGoBack.style.display = 'none';

        this.updateProductText(this.oldProductText);

        this.startButton.style.display = 'flex';
        this.backButtonContainer.style.display = 'none';
        this.undoButton.style.display = 'none';
        return true;
    }

    startCropper() {
        // this.displayButtonNormal();
        this.displayApp.toggleLoading();

        // destroy cropper if it exists
        if (this.cropper) this.cropper.destroy();
        this.loadCropper();
    }

    loadCropper() {
        this.cropper = new Cropper(this.elementToCrop, this.options);
    }

    // Say someone has clicked crop, then upload button
    // we're now on a new image, we should fully restart here.
    restart() {
        // this.interacted = false;
        if (this.cropper) this.cropper.destroy();
        this.displayButtonNormal();
    }

    async uploadPicture(file) {
        this.displayApp.toggleLoading();

        // Response
        // send to render recommendations and update the main product.
        const myHeaders = {
            'api-key': this.displayApp.productPageInfo.retailerConfig.apiKey,
        };
        const payload = new FormData();
        payload.append('image', file);
        payload.append('accountId', this.displayApp.productPageInfo.retailerId);
        payload.append('cache', this.displayApp.productPageInfo.retailerConfig.useCache);

        // Now add in the filters if any exist
        // for (const filter in this.apiFilter) {
        //     if (this.displayApp.apiFilter.hasOwnProperty(filter)) {
        //         payload.append(filter, this.displayApp.apiFilter[filter]);
        //     }
        // }

        // Parent api filter
        if (this.displayApp?.apiFilter?.genderFiltering && this.displayApp?.product?.gender) {
            const productGender = this.displayApp.product.gender;
            payload.append('filterGender', productGender);
        }

        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: payload,
            redirect: 'follow',
        };

        try {
            const response = await fetch(this.displayApp.productPageInfo.retailerConfig.urls.apis.image_uploader_api, requestOptions);
            const result = await response.json();
            const title = this.initalProductData.title ?? 'Your Image';
            const imageURL = { title };
            imageURL.url = URL.createObjectURL(file);
            this.displayApp.uploadResponseAnalytics();
            const newFeed = result.response.response_object.new_feed;

            if (newFeed.length === 0) {
                this.displayApp.toggleLoading();
                this.displayApp.errorPage(
                    this.displayApp.language.upload_button_app.modal.title,
                    'No recommendations found for this image. Please try again with a different image.',
                );
            } else {
                this.displayApp.renderUploadRecommendations(newFeed, file, title);
            }

            return newFeed;
        } catch (error) {
            this.displayApp.toggleLoading();
            this.displayApp.errorPage(
                this.displayApp.language.upload_button_app.modal.title,
                this.displayApp.language.upload_button_app.modal.description,
            );
        }
    }

    preloadCropper() {
        return true;
    }

    async processImage() {
        const file = this.getCroppedImageAsFile();
        const results = await this.uploadPicture(file);
        return results;
    }

    getCroppedImageAsFile() {
        const result = this.cropper.getCroppedCanvas().toDataURL('image/jpeg');
        const file = this.dataURLtoFile(result, 'croppedImage.jpg');
        return file;
    }

    dataURLtoFile(data, filename) {
        const arr = data.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }

    getDefaultOptions() {
        return {
            thisContext: this,
            viewMode: 1,
            zoomOnTouch: false,
            zoomOnWheel: false,
            zoomable: false,
            rotatable: false,
            scalable: false,
            toggleDragModeOnDblclick: false,
            autoCrop: false,
            ready() {
                this.cropper.options.thisContext.displayApp.toggleLoading();
                this.cropper.crop();
            },
        };
    }
}
